import { render, staticRenderFns } from "./RelatedSection.vue?vue&type=template&id=891af32c&"
import script from "./RelatedSection.vue?vue&type=script&lang=js&"
export * from "./RelatedSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports